var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(" "+_vm._s(_vm.$t("Review details"))+" ")]),_c('wise-account-preview',{attrs:{"account":_vm.account}}),_c('b-btn',{staticClass:"mt-3",attrs:{"disabled":_vm.submitting,"variant":"primary","size":"lg","block":"","pill":""},on:{"click":_vm.submit}},[_vm._v(" "+_vm._s(_vm.$t("Submit Withdrawal"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }